export default () => {

    return {

        mounted() {
            
            document.getElementById('launchStateModal').onclick = function sortStates(e) {
                const parent = document.querySelector("#state-list"),
                itemsArray = Array.prototype.slice.call(parent.children);
        
                itemsArray.sort(function (a, b) {
                    if (a.innerText < b.innerText) return -1;
                    if (a.innerText > b.innerText) return 1;
                    return 0;
                });
        
                itemsArray.forEach(function (item) {
                    parent.appendChild(item);
                });
            }
        }

    }

}